/*
 * Official Taste Tester cart opt-in — live-sync behaviour.
 *
 * Loaded once per page (see layout/theme.liquid).
 *
 * Uses a single DOCUMENT-level, CAPTURE-phase change listener (delegation)
 * rather than per-element listeners. Why:
 *   - The cart drawer is re-rendered via innerHTML by Dawn and several apps on
 *     this store, so any element/instance may be replaced at any time. A
 *     listener on `document` survives every re-render and handles whatever
 *     <taste-tester-optin> is present.
 *   - Capture phase lets us stopPropagation BEFORE the event reaches
 *     <cart-drawer-items>, whose bubble-phase change handler would otherwise
 *     treat our checkbox/phone changes as line-item quantity updates.
 *
 * The authoritative path to the order is the native cart-form submit (the
 * fields are <input form="CartDrawer-Form"> / in the cart form), which carries
 * the values on checkout regardless of this script. This live-sync keeps the
 * choice persisted server-side so it survives AJAX drawer re-renders too.
 *
 * A single debounced request writes the FULL state of all three attributes;
 * sending them separately raced concurrent /cart/update calls and dropped data.
 *
 * See snippets/taste-tester-optin.liquid and TASTE-TESTER-OPTIN.md.
 */
(function () {
  var timer = null;

  function sync(root) {
    var main = root.querySelector('[data-tt-main]');
    var phone = root.querySelector('[data-tt-phone]');
    var sms = root.querySelector('[data-tt-sms]');
    var optedIn = !!(main && main.checked);
    var attributes = {
      // Empty string removes an attribute (unchecked / empty => absent).
      official_taste_tester: optedIn ? 'yes' : '',
      taste_tester_phone: optedIn && phone ? phone.value.trim() : '',
      taste_tester_sms_consent: optedIn && sms && sms.checked ? 'yes' : '',
    };
    var url = root.dataset.updateUrl || '/cart/update.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () {
      /* non-blocking: fields still submit with the cart form at checkout */
    });
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      var root = target && target.closest ? target.closest('taste-tester-optin') : null;
      if (!root) return;

      // Keep this out of <cart-drawer-items>' quantity-update handler.
      event.stopPropagation();

      var main = root.querySelector('[data-tt-main]');
      var smsBlock = root.querySelector('[data-tt-sms-block]');
      var phone = root.querySelector('[data-tt-phone]');
      var sms = root.querySelector('[data-tt-sms]');
      var optedIn = !!(main && main.checked);

      // Reveal / hide the SMS sub-block; clear its fields when opting out.
      if (smsBlock) smsBlock.hidden = !optedIn;
      if (!optedIn) {
        if (phone) phone.value = '';
        if (sms) sms.checked = false;
      }

      clearTimeout(timer);
      timer = setTimeout(function () {
        sync(root);
      }, 250);
    },
    true // capture phase
  );
})();
